import { createSelector } from 'reselect';

import { createKeySelector } from 'Lib/reduxUtils';

/**
 * Gets loading namespace from the state
 *
 * @param  {GlobalStateType} state - top-level state
 * @return {LoadingState} entities by type
 */
export const selectLoading = createKeySelector('loading');

/**
 * Gets whether app is loading from the top-level state
 *
 * @param  {GlobalStateType} state - top-level state
 * @return {boolean} true if app is loading
 */
export const getIsAppLoading = createSelector(selectLoading, (loading) => loading.global.loading);
